import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/toast/toast.component';
import { BrandFaviconService } from './shared/brand-favicon.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  template: '<router-outlet></router-outlet><app-toast></app-toast>'
})
export class AppComponent implements OnInit {
  title = 'Automaeta';

  private readonly favicon = inject(BrandFaviconService);

  ngOnInit(): void {
    // Initialize theme from localStorage on app startup
    this.applyTheme();
    // Automaeta icon on marketing routes, Kytelos icon on /v2
    this.favicon.init();
  }

  /**
   * Apply theme classes to the document body and sync data-bs-theme for Bootstrap
   */
  private applyTheme(): void {
    const savedTheme = localStorage.getItem('theme') as 'dark' | 'light' | null;
    const theme = savedTheme || 'dark';
    
    if (theme === 'dark') {
      document.body.classList.add('theme-dark');
      document.body.classList.remove('theme-light');
      document.documentElement.setAttribute('data-bs-theme', 'dark');
    } else {
      document.body.classList.add('theme-light');
      document.body.classList.remove('theme-dark');
      document.documentElement.setAttribute('data-bs-theme', 'light');
    }
  }
}

